import axios from "axios";

export const APIURL = process.env.REACT_APP_API_ENDPOINT;

export const BUSINESSES_URL = APIURL + "/business";

// CREATE =>  POST: register a new business to the server
export function createBusiness(business) {
	return axios.post(`${BUSINESSES_URL}/create`, business);
}

// READ
export function getAllBusinesses() {
  return axios.get(BUSINESSES_URL);
}

export function getBusinessById(businessId) {
	return axios.get(`${BUSINESSES_URL}/find/${businessId}`);
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findBusinesses(queryParams) {
  return axios.post(`${BUSINESSES_URL}/find`, { queryParams });
}

// UPDATE => PUT: update the business on the server
export function updateBusiness(business) {
  return axios.post(`${BUSINESSES_URL}/update/${business.id}`, { business });
}

export function reportBusiness(business_id , added_by ,  is_report , report_fields ) {
  return axios.post(`${BUSINESSES_URL}/reportBusiness`, {business_id , added_by ,  is_report , report_fields  });
}

// UPDATE Status
export function updateStatusForBusinesses(ids, status, message, type) {
    return axios.post(`${BUSINESSES_URL}/updateStatusForBusinesses`, { ids, status, message, type });
}
//For Single Business
export function updateStatusForBusiness(id, status, message) {
  return axios.post(`${BUSINESSES_URL}/updateStatusForBusiness`, { id, status, message });
}
// DELETE => delete the business from the server
export function deleteBusiness(id) {
 return axios.post(`${BUSINESSES_URL}/delete`, { id });
}

// DELETE Businesses by ids
export function deleteBusinesses(ids) {
  return axios.post(`${BUSINESSES_URL}/deleteBusinesses`, { ids });
}

// DELETE Images
export function deleteImages(item) {
  return axios.post(`${BUSINESSES_URL}/deleteImages`, { item });
}
// updateLogo Logo
export function updateLogo(bid,logourl) {
  return axios.post(`${BUSINESSES_URL}/updateLogo`, { bid, logourl});
}

// updateImageOrder
export function updateImageOrder(id, order) {
  return axios.post(`${BUSINESSES_URL}/updateImageOrder`, { id, order });
}

// getDownloadUrl 
export function getDownloadUrl(url) {
  return axios.post(`${BUSINESSES_URL}/getDownloadUrl`, {url});
}
//upload Images
export function UploadImages(businessImage) {
  return axios.post(`${BUSINESSES_URL}/upload_images`, { businessImage });
 }

//upload Images
export function UploadCoverImages(businessImage) {
  return axios.post(`${BUSINESSES_URL}/cover/upload_images`, { businessImage });
 }

 //For Business Premium Status
export function updateBusinessPremiumStatus(id, is_purchased, expiry) {
  return axios.post(`${BUSINESSES_URL}/updateBusinessPremiumStatus`, { id, is_purchased, expiry });
}

export function sendCustomEmail(userid, email, subject, message) {
  return axios.post(`${APIURL}/user/sendEmail`, { userid, email, subject, message });
}

// Geocode address via Google API proxy
export function geocodeAddress(address) {
  return axios.get(`${BUSINESSES_URL}/geocode`, { params: { address } });
}
